<template>
	<div v-if="credentialSelectorFields && credentialSelectorFields.length > 0">
		Choose field as source
		<v-autocomplete
			outlined
			single-line
			hide-details
			item-value="id"
			item-text="title"
			class="dropdown-ac"
			v-model="selectedSourceField"
			append-icon="mdi-chevron-down"
			:items="credentialSelectorFields"
		/>
		<span class="link-style" @click="$emit('cancel')" v-if="selectedSourceField">Cancel</span><br />
	</div>
	<div v-else>
		<ConnectionMappingTitle
			class="mb-1"
			:serviceId="serviceId"
			:credentialsData="credentialsData"
			:configurationType="configurationType"
			:credentialSelectorFields="credentialSelectorFields"
		/>
		<div class="create-new-connection-container flex-centerize flex-column width-100 px-5">
			<div class="connection-description mb-4">No {{ serviceName }} connection block in {{ configurationType }} setup</div>
			<div v-if="!loading" @click="createSource" class="create-new-button-container flex-centerize width-100 px-3">
				Create a {{ serviceName }} connection block in {{ configurationType }} setup
			</div>
			<AppLoader v-else />
		</div>
		<div class="link-text width-100 display-flex flex-row flex-justify-end mt-1" @click="openSetup">Open setup</div>
	</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { getService } from '@/store/modules/apps/getters';
import { DRAWER_MODES } from '@/store/modules/leftSideDrawer/state';
import ConnectionMappingTitle from '@/components/common/ProfileSelector/ConnectionMappingTitle.vue';

export default {
	name: 'ChooseConfigurationFieldAsSource',
	props: {
		serviceId: { type: Number },
		sourceField: { type: String },
		credentialsData: { type: Object },
		credentialsType: { type: String },
		configurationType: { type: String },
		credentialSelectorFields: { type: Array },
	},
	components: {
		ConnectionMappingTitle,
	},
	computed: {
		...mapGetters([getService.fullPath]),
		selectedApp() {
			return this[getService.fullPath](this.serviceId) || {};
		},
		serviceName() {
			return this.selectedApp.service_name;
		},

		selectedSourceField: {
			get() {
				return this.sourceField;
			},
			set(value) {
				this.$emit('update:sourceField', value);
			},
		},
	},
	methods: {
		...mapActions(['leftSideDrawer/setLeftSideDrawerState']),
		createSource() {
			this.loading = true;
			this.$emit('create-source');
		},
		openSetup() {
			this['leftSideDrawer/setLeftSideDrawerState'](DRAWER_MODES.test);
		},
	},
	data() {
		return {
			loading: false,
		};
	},
	mounted() {
		if (this.credentialSelectorFields?.length > 0 && !this.selectedSourceField) {
			// Automattically choose the first connection option if theres more than one, and theres no previous selection
			this.$emit('update:sourceField', this.credentialSelectorFields[0].id);
		}
	},
};
</script>

<style lang="scss" scoped>
.dropdown-ac {
	::v-deep {
		.v-label {
			font-size: 12px;
			margin-top: -10px;
		}
		.v-input__icon {
			margin-top: -10px;
		}
	}
}
.link-text {
	opacity: 0.5;
	font-size: 12px;
	cursor: pointer;
	text-decoration: underline;
	color: var(--profile-selection-grey);
}

.create-new-connection-container {
	height: 105px;
	border-radius: 10px;
	border: 1px solid var(--border-color);
	background: var(--setup-node-container-background);

	.connection-description {
		font-size: 12px;
		font-weight: 600;
		color: var(--profile-selection-grey);
	}

	.create-new-button-container {
		font-size: 14px;
		cursor: pointer;
		text-align: center;
		color: var(--primary-color);

		height: 38px;
		border-radius: 6px;
		background: var(--bg-color);
		border: 1px dashed var(--primary-color);
		&:hover {
			border: 1px solid var(--primary-color);
		}
	}
}
</style>
